import React from 'react';
import ReactDOM from 'react-dom';
import {firebase} from './firebase';

//Components And Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import App from './App';

// import registerServiceWorker from './registerServiceWorker';
firebase.auth().onAuthStateChanged((user)=>{
    ReactDOM.render(<App user={user}/>, document.getElementById('root'));
});
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js